import React from "react";
import { Card, Table, Layout, Space, Typography } from "antd";
import { fmtDateTime } from "../../../common/Utils";
import { usePostComments } from "../../../hooks/content/usePostComments";
import { FiltersBar } from "../../../components/filter/FiltersBar";

export const PostComments = () => {
  const { data,   pagination, loading, filters, del, setFilters, refresh, reset, onSearch, setSortedInfo } =
    usePostComments();

  const onChange = (pagination, filters, sorter) => {
    setSortedInfo(sorter);
  };

  const columns = [
    { title: "", key: "i", render: (t, r, i) => i + 1 },
    {
      title: "User",
      dataIndex: "createdBy",
    },
    {
      title: "Time",
      dataIndex: "CreatedAt",
      render: fmtDateTime,
    },
    {
      title: "Comment",
      dataIndex: "Comment",
      width: "70%",
      render: (v) => <Typography.Paragraph style={{ overflowWrap: "anywhere" }}>{v}</Typography.Paragraph>,
    },
    {
      title: "",
      render: (_, r) => <Space> {r.Deleted ? "Deleted" : <a onClick={() => del(r)}>Delete</a>}</Space>,
    },
  ];

  return (
    <Layout.Content className="padding24">
      <FiltersBar
        filters={filters}
        cfg={{}}
        search={onSearch}
        refresh={refresh}
        reset={reset}
        setFilters={setFilters}
        actionsSpan={8}
      ></FiltersBar>

      <Card size="small">
        <Table
          size="small"
          pagination={pagination}
          loading={loading}
          rowKey="CommentId"
          columns={columns}
          dataSource={data.items}
          onChange={onChange}
        />
      </Card>
    </Layout.Content>
  );
};
